export default __webpack_public_path__ + "static/media/background-parents-day.71a3fccd.jpg";